import { CheckboxFilterGroup, FilterPanel } from '../../generic/Filter';
import type { LicensingIdentification } from '../../../../shared/issuesV2';
import type { SelectedOptionsProps } from '../../generic/Filter';

const FILTER_OPTIONS: Array<{ key: LicensingIdentification, label: string }> = [
  { key: 'declared', label: 'Declared' },
  { key: 'discovered', label: 'Discovered' },
];

const LicenseIdentificationFilter = ({ selectedOptions, onSelect }: SelectedOptionsProps) =>
  <FilterPanel>
    <CheckboxFilterGroup
      title="License Identification"
      options={FILTER_OPTIONS}
      selectedOptions={selectedOptions}
      onSelect={onSelect}
      testId="issues-license-identification-filters"
    />
  </FilterPanel>;

export default LicenseIdentificationFilter;
